export default{
    methods: {
        checkMobile() {
            this.isMobile = window.innerWidth < 768;
        },
        checkMobileAtLoading(){
            this.isMobile = window.innerWidth < 768;
            this.isMobileAtLoading = window.innerWidth < 768;
        },
        checkTablet() {
            this.isTablet = window.innerWidth < 1024;
        },
        checkTabletAtLoading(){
            this.isTablet = window.innerWidth < 1024;
            this.isTabletAtLoading = window.innerWidth < 1024;
        }
    },
    data() {
        return {
            isMobile: null,
            isMobileAtLoading: null,
            isTablet: null,
            isTabletAtLoading: null,
        }
    },
    mounted() {
        this.checkMobileAtLoading();
        this.checkTabletAtLoading();
        window.addEventListener('resize', _.debounce(()=> {
                    this.checkMobile();
                    this.checkTablet();
                }, 300)
        )
    }
}